import { z } from "@hono/zod-openapi";

/**
 * How the truck's trailer changed hands at the stop.
 *
 * `kept`: no trailer was dropped; the truck left with `departingTrailerNumber` (a live unload, or a load with no drop).
 * `swapped`: a trailer was dropped and another hooked — a drop and hook.
 * `droppedOnly`: a trailer was dropped and the truck left bobtail.
 */
export const TrailerExchangeSchema = z.enum(["kept", "swapped", "droppedOnly"]).openapi("TrailerExchange");

export type TrailerExchange = z.infer<typeof TrailerExchangeSchema>;

/** Version 2 of `emptyCall` and `loadedCall`: the stop, and both sides of the trailer exchange. */
export const callTrailerFacts = {
  stopName: z.string(),
  /** Absent on the forms that do not ask for it. */
  city: z.string().nullable(),
  /** Null when the vendor's form did not say. */
  trailerExchange: TrailerExchangeSchema.nullable(),
  /** The trailer left at the stop. Null when none was dropped or the driver left it blank. */
  droppedTrailerNumber: z.string().nullable(),
  /** The trailer the truck left with: hooked on `swapped`, kept on `kept`. Null on `droppedOnly` or when blank. */
  departingTrailerNumber: z.string().nullable(),
};
